import React from "react";
import { KatButton, KatDivider, KatLabel, KatModal } from "@amzn/katal-react";
import { WithTranslation, withTranslation } from "react-i18next";

interface State {
    visible : boolean
}

type Props = WithTranslation;

export class LoginReminderComponent extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            visible: true
        };
    }

    private redirectToLoginVersion(): void {
        window.open('/revcal?ref=RC2nonlogin', '_self');
    }

    render() {
        const {t} = this.props;
        return (
            <>
                <KatModal noCloseIcon={true}  visible={this.state.visible} className="redirect-modal">
                    <img className="logo-image" src="https://m.media-amazon.com/images/I/11Tz2u7Y8wL.png" crossOrigin="anonymous"/>
                    <div slot="footer" className="redirect-modal-content">
                        <div>
                            <KatLabel text={t('SC_FBA_Calc_redirectLogin_Text')}/>
                        </div>
                        <KatButton className="spacing-top-medium" label={t('SC_FBA_Calc_redirectLogin_BtnText')} variant="primary" onClick={() => this.redirectToLoginVersion()}/>
                        <div className="redirect-divider-block">
                            <KatDivider variant="athens" className="redirect-divider"/>
                            <KatLabel text={t('SC_FBA_Calc_Text_or')} className="redirect-divider-text"/>
                            <KatDivider variant="athens" className="redirect-divider"/>
                        </div>
                        <KatButton className="spacing-top-small" label={t('SC_FBA_Calc_redirectLogin_ContinueText')} variant="tertiary" onClick={() => this.setState({visible: false})}/>
                    </div>
                </KatModal>
            </>
        );
    }
}

export default withTranslation()(LoginReminderComponent);